import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-close",
  "use": "icon-l-close-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-close\"><path d=\"M84.4142136 83 101.384776 99.9705627 99.9705627 101.384776 83 84.4142136 66.0294373 101.384776 64.6152237 99.9705627 81.5857864 83 64.6152237 66.0294373 66.0294373 64.6152237 83 81.5857864 99.9705627 64.6152237 101.384776 66.0294373z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol